import { useState, useEffect } from 'react';
import { fetchCourses } from '../services/api';

const STUDY_LEVEL_ORDER = [
  'Pre-University',
  'Undergraduate',
  'Postgraduate',
  'Other',
];

export const useCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCourses = async () => {
      try {
        const courseOptions = await fetchCourses();
        const groupedCourses = courseOptions.reduce((acc, course) => {
          const group = course.studyLevel || 'Other';
          if (!acc[group]) {
            acc[group] = [];
          }
          acc[group].push(course);
          return acc;
        }, {});

        const formattedCourses = Object.entries(groupedCourses)
          .sort(([groupA], [groupB]) => {
            const indexA = STUDY_LEVEL_ORDER.indexOf(groupA);
            const indexB = STUDY_LEVEL_ORDER.indexOf(groupB);
            return indexA - indexB;
          })
          .map(([group, options]) => ({
            label: group,
            options: options.sort((a, b) => a.label.localeCompare(b.label))
        }));
        setCourses(formattedCourses);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    
    loadCourses();
  }, []);

  return { courses, loading, error };
};
